import React from 'react';

// Import หน้าจอ BillOfSale มาแสดงบน Modal
import Form from '../../pages/SellProducts/BillOfSale/Form';

// Report
import { getReport } from '../../../utils/ReportUtils';

const ViewSoModal = ({ showViewSoModal, handleViewSoClose, mode, name, maxDocNo }) => {
    return (
        <div
            className={`modal fade ${showViewSoModal ? 'show' : ''}`}
            style={{
                display: showViewSoModal ? 'block' : 'none',
                overflowY: 'auto', // ให้สามารถเลื่อนดูได้หากเนื้อหายาวเกิน
                backgroundColor: 'rgba(0, 0, 0, 0.1)' // เพิ่มความโปร่งใสพื้นหลัง
            }}
            tabIndex="-1"
            role="dialog"
        >
            <div
                className="modal-dialog modal-xl"
                role="document"
                style={{
                    maxWidth: '90%', // ลดความกว้างให้อยู่ในขอบเขตหน้าจอ
                    margin: '1.75rem auto', // เพิ่มระยะห่างด้านบน-ล่าง
                }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="card-title">{name || 'รายละเอียดใบขาย'}</h4>
                        <div style={{ marginLeft: "auto", marginRight: "30px" }}>
                            {/* <button
                                className="btn btn-lg btn-success"
                                onClick={() => getReport('rc', maxDocNo)}
                                style={{
                                    fontSize: "18px",
                                    color: "white",
                                    marginRight: "30px"
                                }}
                            >
                                พิมพ์ใบแจ้งยอดเงิน
                            </button> */}
                            <button
                                className="btn btn-lg btn-primary"
                                onClick={() => getReport('so', maxDocNo)}
                                style={{
                                    fontSize: "18px",
                                    color: "white"
                                }}
                            >
                                พิมพ์ใบส่งของ/ใบกำกับภาษี
                            </button>
                        </div>
                        <button
                            type="button"
                            className="close"
                            onClick={handleViewSoClose}
                            style={{ fontSize: '1.5rem' }}
                        >
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        {/* เรียกใช้ฟอร์มที่ต้องการ */}
                        <Form
                            callInitialize={null}
                            mode={mode}
                            name={name}
                            maxDocNo={maxDocNo}
                            getReport={null}
                        />
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-danger" onClick={handleViewSoClose}>ปิด</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewSoModal;